/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [登录↗](https://yapi.fenxianglife.com/project/379/interface/api/42652) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/login`
 * @更新时间 `2024-02-01 11:17:45`
 */
export const feimaChatWxRobotLogin = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotLoginRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWxRobotLoginResponse, OT>>(
    '/wxRobot/login',
    'POST',
    data,
    options
  );

/**
 * 接口 [登出↗](https://yapi.fenxianglife.com/project/379/interface/api/42658) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/logout`
 * @更新时间 `2023-10-25 15:35:14`
 */
export const feimaChatWxRobotLogout = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotLogoutRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWxRobotLogoutResponse, OT>>(
    '/wxRobot/logout',
    'POST',
    data,
    options
  );

/**
 * 接口 [群聊列表↗](https://yapi.fenxianglife.com/project/379/interface/api/42664) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/group/list`
 * @更新时间 `2023-10-09 19:06:06`
 */
export const feimaChatWxRobotGroupList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotGroupListRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWxRobotGroupListResponse, OT>>(
    '/wxRobot/group/list',
    'POST',
    data,
    options
  );

/**
 * 接口 [查询微信智能体信息↗](https://yapi.fenxianglife.com/project/379/interface/api/42670) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/info`
 * @更新时间 `2023-11-15 15:30:27`
 */
export const feimaChatWxRobotInfo = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotInfoRequest>,
  options?: OT
) => {
  // 企业微信 临时禁用
  return Promise.resolve({} as any)
  // return request<ToolTypes.GetResponseType<API.FeimaChatWxRobotInfoResponse, OT>>(
  //   '/wxRobot/info',
  //   'POST',
  //   data,
  //   options
  // );
}

/**
 * 接口 [查询微信群聊天记录↗](https://yapi.fenxianglife.com/project/379/interface/api/42958) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/group/messages/all`
 * @更新时间 `2023-10-09 18:52:06`
 */
export const feimaChatWxRobotGroupMessagesAll = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotGroupMessagesAllRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxRobotGroupMessagesAllResponse, OT>
  >('/wxRobot/group/messages/all', 'POST', data, options);

/**
 * 接口 [查询微信群单聊记录↗](https://yapi.fenxianglife.com/project/379/interface/api/42964) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/group/messages/single`
 * @更新时间 `2023-08-23 13:43:14`
 */
export const feimaChatWxRobotGroupMessagesSingle = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotGroupMessagesSingleRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatWxRobotGroupMessagesSingleResponse,
      OT
    >
  >('/wxRobot/group/messages/single', 'POST', data, options);

/**
 * 接口 [微信群聊天记录统计↗](https://yapi.fenxianglife.com/project/379/interface/api/42970) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/group/message/statistics`
 * @更新时间 `2023-08-22 13:01:39`
 */
export const feimaChatWxRobotGroupMessageStatistics = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotGroupMessageStatisticsRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatWxRobotGroupMessageStatisticsResponse,
      OT
    >
  >('/wxRobot/group/message/statistics', 'POST', data, options);

/**
 * 接口 [群聊标签列表↗](https://yapi.fenxianglife.com/project/379/interface/api/44602) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/group/tag/list`
 * @更新时间 `2023-12-06 17:07:42`
 */
export const feimaChatWxRobotGroupTagList = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotGroupTagListRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxRobotGroupTagListResponse, OT>
  >('/wxRobot/group/tag/list', 'POST', data, options);

/**
 * 接口 [群聊打标↗](https://yapi.fenxianglife.com/project/379/interface/api/44608) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/group/tag/add`
 * @更新时间 `2023-12-06 17:07:32`
 */
export const feimaChatWxRobotGroupTagAdd = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotGroupTagAddRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxRobotGroupTagAddResponse, OT>
  >('/wxRobot/group/tag/add', 'POST', data, options);

/**
 * 接口 [群聊数据统计↗](https://yapi.fenxianglife.com/project/379/interface/api/44614) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/group/data/statistics`
 * @更新时间 `2023-10-09 19:59:22`
 */
export const feimaChatWxRobotGroupDataStatistics = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotGroupDataStatisticsRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatWxRobotGroupDataStatisticsResponse,
      OT
    >
  >('/wxRobot/group/data/statistics', 'POST', data, options);

/**
 * 接口 [登录(侧边栏使用)↗](https://yapi.fenxianglife.com/project/379/interface/api/45862) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/login/cp`
 * @更新时间 `2023-11-09 10:12:25`
 */
export const feimaChatWxRobotLoginCp = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotLoginCpRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWxRobotLoginCpResponse, OT>>(
    '/wxRobot/login/cp',
    'POST',
    data,
    options
  );

/**
 * 接口 [查询微信智能体信息(企微侧边栏使用)↗](https://yapi.fenxianglife.com/project/379/interface/api/45868) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/info/cp`
 * @更新时间 `2023-11-09 10:13:12`
 */
export const feimaChatWxRobotInfoCp = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotInfoCpRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatWxRobotInfoCpResponse, OT>>(
    '/wxRobot/info/cp',
    'POST',
    data,
    options
  );

/**
 * 接口 [验证二维码↗](https://yapi.fenxianglife.com/project/379/interface/api/46114) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/login/checkQRCode`
 * @更新时间 `2023-11-15 11:27:40`
 */
export const feimaChatWxRobotLoginCheckQrCode = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotLoginCheckQrCodeRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<API.FeimaChatWxRobotLoginCheckQrCodeResponse, OT>
  >('/wxRobot/login/checkQRCode', 'POST', data, options);

/**
 * 接口 [获取安全验证二维码↗](https://yapi.fenxianglife.com/project/379/interface/api/50416) 的 **请求函数**
 *
 * @分类 [微信智能体相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9989)
 * @请求头 `POST /wxRobot/login/securityCheck`
 * @更新时间 `2024-04-19 10:14:59`
 */
export const feimaChatWxRobotLoginSecurityCheck = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatWxRobotLoginSecurityCheckRequest>,
  options?: OT
) =>
  request<
    ToolTypes.GetResponseType<
      API.FeimaChatWxRobotLoginSecurityCheckResponse,
      OT
    >
  >('/wxRobot/login/securityCheck', 'POST', data, options);

/* prettier-ignore-end */
